module.exports = __webpack_public_path__ + "img/violet_086.6ac5f3ff.png";